// extracted by mini-css-extract-plugin
module.exports = {"root":"_2oKeI","title":"_2uwx2","bold":"LSdVQ"};